<template>
  <v-app>
    <v-container class="py-10" fluid style="background-color: white">
      <v-card class="mt-6">
        <div class="card-header-padding">
          <v-row justify="space-between">
            <v-col cols="6">
              <h5 class="font-weight-bold text-h5 text-typo mb-0">
                Төгсөлт
                <span v-if="selectedClassGroup" class="grey--text">
                  ({{ selectedClassGroup.STUDENT_GROUP_ID }})</span
                >
              </h5>
            </v-col>
          </v-row>
        </div>
        <v-row class="mx-4" justify="start">
          <!-- <v-col cols="9"
            ><p class="text-typo"></p>

            <v-alert
              color="#d81b60"
              class="pt-4"
              text
              prominent
              icon="mdi-information-slab-circle"
            >
              <p class="mb-0">
              </p>
            </v-alert>
          </v-col>
          <v-spacer></v-spacer> -->
          <v-col cols="3">
            <v-select
              clearable
              v-if="allClassGroups"
              return-object
              v-model="selectedClassGroup"
              :items="allClassGroups"
              item-text="name"
              item-value="id"
              label="Бүлэг сонгоx"
            >
              <template #item="{ item }">
                <v-row>
                  <v-col>
                    <span class="text-typo"
                      >{{ item.index }}.
                      <span class="blue--text">{{ item.name }}</span></span
                    >
                  </v-col>

                  <v-col class="text-end">
                    <small style="color: #bbb"
                      >{{ item.ACADEMIC_LEVEL }} -р анги</small
                    >
                  </v-col>
                </v-row>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-progress-linear
          class="mx-4 mt-4"
          v-if="loading"
          color="red"
          height="6"
          indeterminate
        ></v-progress-linear>

        <v-container fluid style="background-color: white">
          <v-tabs
            v-model="selectedStep"
            style="background-color: white; color: white !important"
            slider-color="red"
          >
            <v-tab
              :class="{ 'active-tab': selectedStep === 0 }"
              style="font-size: 9pt !important"
            >
              {{ finalSteps[0].label }}</v-tab
            >
            <v-tab
              :class="{ 'active-tab': selectedStep === 1 }"
              style="font-size: 9pt !important"
            >
              {{ finalSteps[1].label }}</v-tab
            >
            <v-tab
              :class="{ 'active-tab': selectedStep === 2 }"
              style="font-size: 9pt !important"
            >
              {{ finalSteps[2].label }}</v-tab
            >
            <v-tab
              :class="{ 'active-tab': selectedStep === 3 }"
              style="font-size: 9pt !important"
            >
              {{ finalSteps[3].label }}</v-tab
            >
            <v-tab
              :class="{ 'active-tab': selectedStep === 4 }"
              style="font-size: 9pt !important"
            >
              {{ finalSteps[4].label }}</v-tab
            >
            <v-tab
              :class="{ 'active-tab': selectedStep === 5 }"
              style="font-size: 9pt !important"
            >
              {{ finalSteps[5].label }}</v-tab
            >
            <v-tab
              :class="{ 'active-tab': selectedStep === 6 }"
              style="font-size: 9pt !important"
            >
              {{ finalSteps[6].label }}</v-tab
            >
            <v-tab
              :class="{ 'active-tab': selectedStep === 7 }"
              style="font-size: 9pt !important"
            >
              Төгсөгчөөс элсэх бүртгэл
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="selectedStep">
            <v-tab-item class="px-4 pb-10 pt-4">
              <TMonitoring
                v-if="selectedClassGroup && classStudents"
                :selectedClassGroup="selectedClassGroup"
                :classStudents="classStudents"
              ></TMonitoring>
            </v-tab-item>
            <v-tab-item>
              <DevshiltStep2 :selectedClassGroup="selectedClassGroup" />
            </v-tab-item>
            <v-tab-item>
              <TogsoltStep3
                :selectedClassGroup="selectedClassGroup"
                :classStudents="classStudents"
              />
            </v-tab-item>
            <v-tab-item>
              <TogsoltStep4
                :selectedClassGroup="selectedClassGroup"
                :classStudents="classStudents"
              />
            </v-tab-item>
            <v-tab-item>
              <TogsoltStep5
                :selectedClassGroup="selectedClassGroup"
                :allFinalExamsCalendars="allFinalExamsCalendars"
                :classStudents="classStudents"
              />
            </v-tab-item>
            <v-tab-item>
              <TogsoltStep6
                :selectedClassGroup="selectedClassGroup"
                :classStudents="classStudents"
                :tokenData="tokenData"
              />
            </v-tab-item>
            <v-tab-item>
              <TogsoltStep7
                :selectedClassGroup="selectedClassGroup"
                :classStudents="classStudents"
                :tokenData="tokenData"
              />
            </v-tab-item>
            <v-tab-item>
              <TogsoltStep8
                :selectedClassGroup="selectedClassGroup"
                :classStudents="classStudents"
                :tokenData="tokenData"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-container>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
import { sync } from "vuex-pathify";
import TMonitoring from "./TMonitoring.vue";

import DevshiltStep2 from "./DevshiltStep2.vue";
import TogsoltStep3 from "./TogsoltStep3.vue";
import TogsoltStep4 from "./TogsoltStep4.vue";
import TogsoltStep5 from "./TogsoltStep5.vue";
import TogsoltStep6 from "./TogsoltStep6.vue";
import TogsoltStep7 from "./TogsoltStep7.vue";
import TogsoltStep8 from "./TogsoltStep8.vue";
import axios from "axios";
export default {
  name: "FinalYearClosing",
  data() {
    return {
      tokenData: null,
      allFinalExamsCalendars: null,
      classStudents: null,
      selectedStep: 0,
      finalSteps: [
        { label: "Хянах самбар", description: "Overview of the dashboard" },
        { label: "Журнал нэгтгэл", description: "Journal and records" },
        { label: "Хичээлийн ДҮН", description: "Grade results overview" },
        { label: "Судалгаахууны дүн", description: "Research scores" },
        { label: "Шалгалтын нэгтгэл", description: "Exam reports" },
        { label: "Төгсөлтийн бүртгэл", description: "Graduation registration" },
        { label: "Баримт бичиг", description: "Document records" },
        {
          label: "Төгсөгчөөс элсэх бүртгэл",
          description: "Alumni registration",
        },
      ],

      renderComponent: true,
      selectedClassGroup: null,
      allClassGroups: null,
      departments: null,
      allWeeks: null,
      currentSelectedSemester: null,
    };
  },
  components: {
    TMonitoring,
    DevshiltStep2,
    TogsoltStep3,
    TogsoltStep4,
    TogsoltStep5,
    TogsoltStep6,
    TogsoltStep7,
    TogsoltStep8,
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
    filteredLessons() {
      var list = [];
      var counter = 0;
      if (this.lessons) {
        for (var ll of this.lessons) {
          counter++;
          ll.index = counter;
          ll.uniqueId = ll.id + counter;
          ll.name3 = counter + ". " + ll.name2;
          list.push(ll);
        }
      }
      return list;
    },
    allLessonTime() {
      if (this.teacherLessons) {
        var summe = 0;
        for (const ll of this.teacherLessons) {
          if (
            ll._calDatas &&
            ll._calDatas.filter((xx) => xx[0] == this.currentSelectedSemester)
          ) {
            summe = summe + ll._calDatas.length;
          }
        }
      }
      return summe;
    },
  },
  watch: {
    selectedStep(val) {
      console.log(
        val,
        "selectedClassGroup",
        this.selectedClassGroup.STUDENT_GROUP_ID
      );
      // console.log(
      //   "this.allFinalExamsCalendars",
      //   this.allFinalExamsCalendars,
      //   this.allFinalExamsCalendars && this.allFinalExamsCalendars.length > 0
      // );
      // // /schools/LMDQ0DnxrlpaMaxvOvej/stateExams-2025/classGroupId-100004279047343/exams/examId-100004912319875
      // if (
      //   val == 2 &&
      //   !(this.allFinalExamsCalendars && this.allFinalExamsCalendars.length > 0)
      // ) {

      // } else {
      //   console.log("not necessary to read it");
      // }
    },
    selectedClassGroup(val) {
      if (val) {
        this.allFinalExamsCalendars = null;
        this.loading = true;
        this.userData.school.ref
          .collection("students-" + this.userData.school.currentYear)
          .where("STUDENT_GROUP_ID", "==", val.STUDENT_GROUP_ID)
          .where("deleted", "==", false)
          .orderBy("firstName", "asc")
          .get()
          .then((docs) => {
            var counter = 0;
            this.classStudents = [];
            this.allFinalExamsCalendars = [];
            docs.forEach(async (doc) => {
              let student = doc.data();
              student.id = doc.id;
              student.ref = doc.ref;

              if (!student.moved) {
                student.name = student.LAST_NAME
                  ? student.LAST_NAME[0] + ". " + student.FIRST_NAME
                  : "" + student.FIRST_NAME;
                student.bday = student.DATE_OF_BIRTH.replace(
                  "T00:00:00.000Z",
                  ""
                );

                counter++;
                student.index = counter;
                this.classStudents.push(student);
              }
            });
          });
        // this.forceRerender();
      }
      this.forceRerender();
    },
  },
  created() {
    fb.db.doc("/_schoolTokens/" + this.userData.school.id).onSnapshot((doc) => {
      if (doc.exists) {
        var diffInHours =
          (new Date() - doc.data().tokenTakenAt.toDate()) / (1000 * 60 * 60);

        if (diffInHours >= 24) {
          this._loginTakeToken();
        } else {
          this.tokenData = doc.data();
          this.tokenData.ref = doc.ref;
          this.tokenData.id = doc.id;
        }
        console.log("TokEN comming!!!!! for updating", doc.ref.path);
        console.log(doc.data().schoolName);
        console.log("diffInHours", diffInHours);
        console.log(this.userData.school._esisUserName);
        console.log(this.userData.school._esisPword);
      } else {
        this._loginTakeToken();
      }
    });
    this._findClassGroups();
  },

  methods: {
    async forceRerender() {
      this.renderComponent = false;
      await this.$nextTick();
      this.renderComponent = true;
    },
    _findClassGroups() {
      this.loading = true;
      this.allClassGroups = [];

      var filters = [];
      if (
        this.userData.role == "schoolmanager" &&
        this.userData.managerScope &&
        this.userData.managerScope.length < 3
      ) {
        this.userData.managerScope.forEach((scope) => {
          console.log(scope);
          if (scope == 1) {
            filters.push(1, 5);
          }
          if (scope == 2) {
            filters.push(6, 9);
          }
          if (scope == 3) {
            filters.push(10, 12);
          }
        });
      }
      console.log(filters);

      var query = this.userData.school.ref
        .collection("departments-" + this.userData.school.currentYear)
        .orderBy("index", "desc");

      if (this.userData.managerScope && this.userData.managerScope.length < 3) {
        query = query
          .where("index", "<=", Math.max(...filters))
          .where("index", ">=", Math.min(...filters));
      }

      query.get().then((docs) => {
        this.departments = [];
        this.classGroups = [];
        var counter = 0;
        this.numberOfAllGroups = 0;
        docs.forEach((doc) => {
          this.countOfPrograms = 0;
          let dep = doc.data();
          dep.id = doc.id;
          dep.ref = doc.ref;
          dep.classGroups = null;
          this.loading = true;
          dep.ref
            .collection("programs")
            .where("deleted", "==", false)
            .orderBy("name", "asc")
            .get()
            .then((docs) => {
              dep.classGroups = [];
              dep.numberOfStudents = 0;
              docs.forEach(async (doc) => {
                // doc.data() is never undefined for query doc snapshots
                let prog = doc.data();
                prog.id = doc.id;
                prog.ref = doc.ref;
                // if (
                //   prog.numberOfStudents != undefined &&
                //   prog.numberOfStudents != null
                // )
                //   dep.numberOfStudents =
                //     dep.numberOfStudents + prog.numberOfStudents;
                // prog.index = counter++;
                // this.numberOfAllGroups++;
                // prog.loading = false;
                // console.log(prog);
                counter++;
                prog.index = counter;
                dep.classGroups.push(prog);
                if (!this.selectedClassGroup) this.selectedClassGroup = prog;
                this.allClassGroups.push(prog);
              });
              this.loading = false;
            });
          this.departments.push(dep);
        });
        this.loading = false;
      });
    },
    _getDay(dayIndex) {
      var dayName = null;
      switch (dayIndex) {
        case 1:
          dayName = "Да";
          break;
        case 2:
          dayName = "Мя";
          break;
        case 3:
          dayName = "Лх";
          break;
        case 4:
          dayName = "Пү";
          break;
        case 5:
          dayName = "Ба";
          break;
        case 6:
          dayName = "Бя";
          break;
        case 7:
          dayName = "Ня";
          break;
      }
      return dayName;
    },
    _getFormatedCalData(lesson) {
      var calDatas = [];
      if (lesson._calDatas && lesson._calDatas.length > 0) {
        for (const xx of lesson._calDatas) {
          var calData = xx.split("-");
          if (
            calData[0] &&
            calData[0] == String(this.currentSelectedSemester)
          ) {
            var calObject = {
              semester: Number(calData[0]),
              calendarVersion: Number(calData[1]),
              garag: Number(calData[2]),
              garagName: this._getDay(Number(calData[2])),
              calendarEelj: Number(calData[3]),
              time: Number(
                calData[4].startsWith("0") ? calData[4].slice(1) : calData[4]
              ),
            };
            calDatas.push(calObject);
          }
        }
        return calDatas;
      } else return null;
    },
    _loginTakeToken() {
      axios
        .post(
          "https://us-central1-digitalschool-3f1e9.cloudfunctions.net/esislogin",
          {
            username: this.userData.school._esisUserName,
            password: this.userData.school._esisPword,
          }
        )
        .then((res) => {
          fb.db
            .doc("/_schoolTokens/" + this.userData.school.id)
            .set(
              {
                token: res.data.token,
                tokenTakenAt: new Date(),
                schoolName: this.userData.school.name,
              },
              { merge: true }
            )
            .then(() => {
              console.log("TokEN updated!!!!!");
            });
        });
    },
  },
};
</script>
<style>
[data-title2]:hover:after {
  opacity: 1;
  transition: all 0.1s ease 0.5s;
  visibility: visible;
}
[data-title2]:after {
  content: attr(data-title2);
  position: absolute;
  bottom: -1.6em;
  left: 65%;
  padding: 4px 4px 4px 8px;
  color: #222;
  white-space: nowrap;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-box-shadow: 0px 0px 4px #222;
  -webkit-box-shadow: 0px 0px 4px #222;
  box-shadow: 0px 0px 4px #222;
  background: yellow;
  color: black;
  opacity: 0;
  z-index: 99999;
  visibility: hidden;
}
[data-title2] {
  position: relative;
}
.active-tab {
  background-color: #f77f5c;
  color: #ffffff;
}
</style>
